import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12.021,1.98c-5.523,0-10,4.477-10,10c0,5.523,4.477,10,10,10s10-4.477,10-10 C22.021,6.457,17.544,1.98,12.021,1.98z M17.021,12.981h-4v4c0,0.552-0.448,1-1,1s-1-0.448-1-1v-4h-4c-0.552,0-1-0.448-1-1 c0-0.552,0.448-1,1-1h4v-4c0-0.552,0.448-1,1-1s1,0.448,1,1v4h4c0.552,0,1,0.448,1,1C18.021,12.533,17.573,12.981,17.021,12.981z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'PlusFill');

export default Icon;
